import { useProject, useSubTask } from "../../../hooks";
import { useTask } from "../../../hooks/query";
import { useCallback, useEffect } from "react";

export default function useJobExecution(task: any) {
    const { useListSubtask } = useTask();
    const { project } = useProject();
    const { tasks, setTasks } = useSubTask();

    const listSubtaskSvc = useListSubtask();

    const refresh = useCallback(async () => {
        if (!project?.id || !task?.Id) {
            return;
        }

        try {
            const response = await listSubtaskSvc.mutateAsync({
                ProjectId: project.id,
                TaskId: task.Id,
            });
            setTasks(response);
        } catch (e) {
            console.error(e);
        }
        // listSubtaskSvc identity changes every render; intentionally omit from deps
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [project?.id, task?.Id, setTasks]);

    useEffect(() => {
        void refresh();
    }, [refresh]);

    return { tasks, refresh };
}
